import { Call } from '@twilio/voice-sdk';
import { CronoCallEvent } from './cronoCallReducer';
import { isDev } from 'utils/uiHelpers';
import { captureException } from 'utils/exceptionUtils';

export const bindCallEventListeners = ({
  call,
  send,
  onDisconnect,
  wasRecorded,
  onError,
}: {
  call: Call;
  send: React.Dispatch<CronoCallEvent>;
  onDisconnect?: (params: { call: Call; wasRecorded: boolean }) => void;
  wasRecorded: React.MutableRefObject<boolean>;
  onError: (error: unknown) => void;
}) => {
  call.on('accept', (call) => {
    if (isDev()) {
      console.debug(
        "[Crono VoIP] The incoming call was accepted or the outgoing call's media session has finished setting up.",
      );
    }
    send({ type: 'callAccepted', callStart: new Date() });
  });

  call.on('error', (error) => {
    console.error('[Crono VoIP]  The call had an error.', error);
    captureException(error, {
      level: 'error',
    });
    send({ type: 'callErrored' });
    onError(error);
  });

  call.on('disconnect', (call) => {
    if (isDev()) {
      console.debug('[Crono VoIP]  The call has been disconnected.');
    }
    send({ type: 'callDisconnected' });
    onDisconnect?.({
      call,
      wasRecorded: wasRecorded.current,
    });
  });

  call.on('cancel', () => {
    if (isDev()) {
      console.debug('[Crono VoIP]  The call has been canceled.');
    }
    send({ type: 'callCanceled' });
  });

  call.on('mute', (isMuted, call) => {
    if (isDev()) {
      console.debug('[Crono VoIP]  The call has been muted/unmuted.');
    }
    send({ type: 'callMuted', isMuted });
  });

  call.on('reconnected', () => {
    if (isDev()) {
      console.debug('[Crono VoIP] The call has regained connectivity.');
    }
    send({ type: 'callReconnected' });
  });

  call.on('reconnecting', (error) => {
    console.error('[Crono VoIP]  Connectivity error:', error);
    send({ type: 'callReconnecting' });
  });
};
